import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const walletSimulatorContract = c.router({
  exchangeOffer: {
    method: 'GET',
    path: '/wallet-simulator/exchange/:offer/:credential',
    pathParams: z.object({
      offer: z.string(),
      credential: z.string(),
    }),
    responses: {
      200: z.object({
        credential: z.object({
          format: z.string(),
          credential: z.string(),
          c_nonce: z.string(),
          c_nonce_expires_in: z.number(),
        }),
      }),
    },
  },
});
